import { render, staticRenderFns } from "./SeriesCarousel.vue?vue&type=template&id=6c268439&scoped=true&"
import script from "./SeriesCarousel.vue?vue&type=script&lang=js&"
export * from "./SeriesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SeriesCarousel.vue?vue&type=style&index=0&id=6c268439&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c268439",
  null
  
)

export default component.exports